module.exports = __webpack_public_path__ + "static/media/two_uk.97203e7b.svg";